// Theme presets for sidebar themes
export const themePresets = [
  {
    key: 'classic',
    label: 'Classic',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #4e54c8 60%, #8f94fb 100%)',
      '--header-bg': 'linear-gradient(90deg, #e5daff, #c5c8ee)',
      '--menu-item-selected':
        'linear-gradient(90deg, #ff6a00 60%, #ee0979 100%)',
      '--menu-item-hover': 'linear-gradient(90deg, #ee0979 60%, #ff6a00 100%)',
      '--header-title': '#4e54c8',
      '--profile-avatar': '#4e54c8',
      '--welcome-text': '#4e54c8',
      '--welcome-mse': '#888',
      '--have-a-nice-day': 'rgb(203, 55, 244) ',
      '--description-branch': '#444',
    },
    previewColor: '#4e54c8',
  },
  {
    key: 'sunset',
    label: 'Sunset',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #ff9966 60%, #ff5e62 100%)',
      '--header-bg': 'linear-gradient(90deg, #fceabb, #f8b500)',
      '--menu-item-selected':
        'linear-gradient(90deg, #ff9966 60%, #ff5e62 100%)',
      '--menu-item-hover': 'linear-gradient(90deg, #ff5e62 60%, #ff9966 100%)',
      '--header-title': '#ff5e62',
      '--profile-avatar': '#ff9966',
      '--welcome-text': '#ff5e62',
      '--welcome-mse': '#b07d5c',
      '--have-a-nice-day': '#bbb',
      '--description-branch': '#555',
    },
    previewColor: '#ff9966',
  },
  {
    key: 'dark',
    label: 'Dark',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #232526 60%, #414345 100%)',
      '--header-bg': 'linear-gradient(90deg, #232526, #414345)',
      '--menu-item-selected':
        'linear-gradient(90deg, #232526 60%, #414345 100%)',
      '--menu-item-hover': 'linear-gradient(90deg, #414345 60%, #232526 100%)',
      '--header-title': '#fff',
      '--profile-avatar': '#fff',
      '--welcome-text': '#fff',
      '--welcome-mse': '#bbb',
      '--have-a-nice-day': '#ccc',
      '--description-branch': '#666',
    },
    previewColor: '#232526',
  },
  {
    key: 'aqua',
    label: 'Aqua',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #43cea2 60%, #185a9d 100%)',
      '--header-bg': 'linear-gradient(90deg, #43cea2, #185a9d)',
      '--menu-item-selected':
        'linear-gradient(90deg, #43cea2 60%, #185a9d 100%)',
      '--menu-item-hover': 'linear-gradient(90deg, #185a9d 60%, #43cea2 100%)',
      '--header-title': '#185a9d',
      '--profile-avatar': '#43cea2',
      '--welcome-text': '#185a9d',
      '--welcome-mse': '#3a6e6e',
      '--have-a-nice-day': '#ddd',
      '--description-branch': '#777',
    },
    previewColor: '#43cea2',
  },
  {
    key: 'violet',
    label: 'Violet',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #8f94fb 60%, #4e54c8 100%)',
      '--header-bg': 'linear-gradient(90deg, #bba7ed, #cccff6)',
      '--menu-item-selected':
        'linear-gradient(90deg, #8f94fb 60%, #4e54c8 100%)',
      '--menu-item-hover': 'linear-gradient(90deg, #4e54c8 60%, #8f94fb 100%)',
      '--header-title': '#8f94fb',
      '--profile-avatar': '#8f94fb',
      '--welcome-text': '#8f94fb',
      '--welcome-mse': '#555',
      '--have-a-nice-day': '#eee',
      '--description-branch': '#888',
    },
    previewColor: '#8f94fb',
  },
  {
    key: 'rose',
    label: 'Rose',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #f857a6 60%, #ff5858 100%)',
      '--header-bg': 'linear-gradient(90deg, #f857a6, #ff5858)',
      '--menu-item-selected':
        'linear-gradient(90deg, #f857a6 60%, #ff5858 100%)',
      '--menu-item-hover': 'linear-gradient(90deg, #ff5858 60%, #f857a6 100%)',
      '--header-title': '#f857a6',
      '--profile-avatar': '#f857a6',
      '--welcome-text': '#f857a6',
      '--welcome-mse': '#888',
      '--have-a-nice-day': '#fff',
      '--description-branch': '#999',
    },
    previewColor: '#f857a6',
  },
  {
    key: 'ocean',
    label: 'Ocean',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #00c6ff 0%, #0072ff 100%)',
      '--header-bg': 'linear-gradient(90deg, #00c6ff, #0072ff)',
      '--menu-item-selected': 'linear-gradient(90deg, #36d1dc, #5b86e5)',
      '--menu-item-hover': 'linear-gradient(90deg, #5b86e5, #36d1dc)',
      '--header-title': '#ffffff',
      '--profile-avatar': '#36d1dc',
      '--welcome-text': '#ffffff',
      '--welcome-mse': '#555',
      '--have-a-nice-day': '#aaa',
      '--description-branch': '#aaa',
    },
    previewColor: '#00c6ff',
  },
  {
    key: 'sunrise',
    label: 'Sunrise',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #ff512f 0%, #f09819 100%)',
      '--header-bg': 'linear-gradient(90deg, #ff512f, #f09819)',
      '--menu-item-selected': 'linear-gradient(90deg, #ff512f, #dd2476)',
      '--menu-item-hover': 'linear-gradient(90deg, #f09819, #ff512f)',
      '--header-title': '#ffffff',
      '--profile-avatar': '#f09819',
      '--welcome-text': '#ffffff',
      '--welcome-mse': '#888',
      '--have-a-nice-day': '#bbb',
      '--description-branch': '#bbb',
    },
    previewColor: '#ff512f',
  },
  {
    key: 'mint',
    label: 'Mint',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #00b09b 0%, #96c93d 100%)',
      '--header-bg': 'linear-gradient(90deg, #00b09b, #96c93d)',
      '--menu-item-selected': 'linear-gradient(90deg, #43e97b, #38f9d7)',
      '--menu-item-hover': 'linear-gradient(90deg, #38f9d7, #43e97b)',
      '--header-title': '#ffffff',
      '--profile-avatar': '#43e97b',
      '--welcome-text': '#ffffff',
      '--welcome-mse': '#555',
      '--have-a-nice-day': '#ccc',
      '--description-branch': '#ccc',
    },
    previewColor: '#00b09b',
  },
  {
    key: 'plum',
    label: 'Plum',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #41295a 0%, #2f0743 100%)',
      '--header-bg': 'linear-gradient(90deg, #41295a, #2f0743)',
      '--menu-item-selected':
        'linear-gradient(90deg, #833ab4, #fd1d1d, #fcb045)',
      '--menu-item-hover': 'linear-gradient(90deg, #fcb045, #fd1d1d, #833ab4)',
      '--header-title': '#ffffff',
      '--profile-avatar': '#833ab4',
      '--welcome-text': '#ffffff',
      '--welcome-mse': '#888',
      '--have-a-nice-day': '#ddd',
      '--description-branch': '#ddd',
    },
    previewColor: '#41295a',
  },
  {
    key: 'blush',
    label: 'Blush',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #ff9a9e 0%, #fad0c4 100%)',
      '--header-bg': 'linear-gradient(90deg, #ff9a9e, #fad0c4)',
      '--menu-item-selected': 'linear-gradient(90deg, #fad0c4, #ffdde1)',
      '--menu-item-hover': 'linear-gradient(90deg, #ffdde1, #fad0c4)',
      '--header-title': '#8a2be2',
      '--profile-avatar': '#ff9a9e',
      '--welcome-text': '#8a2be2',
      '--welcome-mse': '#555',
      '--have-a-nice-day': '#eee',
      '--description-branch': '#eee',
    },
    previewColor: '#ff9a9e',
  },
  {
    key: 'emerald',
    label: 'Emerald',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #11998e 0%, #38ef7d 100%)',
      '--header-bg': 'linear-gradient(90deg, #11998e, #38ef7d)',
      '--menu-item-selected': 'linear-gradient(90deg, #6dd5ed, #2193b0)',
      '--menu-item-hover': 'linear-gradient(90deg, #2193b0, #6dd5ed)',
      '--header-title': '#ffffff',
      '--profile-avatar': '#38ef7d',
      '--welcome-text': '#ffffff',
      '--welcome-mse': '#555',
      '--have-a-nice-day': '#fff',
      '--description-branch': '#fff',
    },
    previewColor: '#38ef7d',
  },
  {
    key: 'midnight',
    label: 'Midnight',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #232526 0%, #414345 100%)',
      '--header-bg': 'linear-gradient(90deg, #232526, #414345)',
      '--menu-item-selected':
        'linear-gradient(90deg, #0f2027, #203a43, #2c5364)',
      '--menu-item-hover': 'linear-gradient(90deg, #2c5364, #203a43, #0f2027)',
      '--header-title': '#ffffff',
      '--profile-avatar': '#2c5364',
      '--welcome-text': '#ffffff',
      '--welcome-mse': '#888',
      '--have-a-nice-day': '#aaa',
      '--description-branch': '#aaa',
    },
    previewColor: '#2c5364',
  },
  {
    key: 'lavender',
    label: 'Lavender',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #c8c6ff 0%, #e7d1ff 100%)',
      '--header-bg': 'linear-gradient(90deg, #f6f0ff, #dedbff)',
      '--menu-item-selected': 'linear-gradient(90deg, #b19cd9, #8e9ed7)',
      '--menu-item-hover': 'linear-gradient(90deg, #b39ddb, #9575cd)',
      '--header-title': '#7e57c2',
      '--profile-avatar': '#7e57c2',
      '--welcome-text': '#7e57c2',
      '--welcome-mse': '#555',
      '--have-a-nice-day': '#bbb',
      '--description-branch': '#bbb',
    },
    previewColor: '#b19cd9',
  },
  {
    key: 'citrus',
    label: 'Citrus',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #fceabb, #f8b500)',
      '--header-bg': 'linear-gradient(90deg, #f6e27a, #f7d358)',
      '--menu-item-selected': 'linear-gradient(90deg, #f9d423, #ff4e50)',
      '--menu-item-hover': 'linear-gradient(90deg, #ff4e50, #f9d423)',
      '--header-title': '#ff9800',
      '--profile-avatar': '#f8b500',
      '--welcome-text': '#f8b500',
      '--welcome-mse': '#888',
      '--have-a-nice-day': '#ccc',
      '--description-branch': '#ccc',
    },
    previewColor: '#f8b500',
  },
  {
    key: 'teal',
    label: 'Teal',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #1de9b6, #1dc4e9)',
      '--header-bg': 'linear-gradient(90deg, #1de9b6, #1dc4e9)',
      '--menu-item-selected': 'linear-gradient(90deg, #00c9ff, #92fe9d)',
      '--menu-item-hover': 'linear-gradient(90deg, #92fe9d, #00c9ff)',
      '--header-title': '#1dc4e9',
      '--profile-avatar': '#1de9b6',
      '--welcome-text': '#1dc4e9',
      '--welcome-mse': '#555',
      '--have-a-nice-day': '#ddd',
      '--description-branch': '#ddd',
    },
    previewColor: '#1dc4e9',
  },
  {
    key: 'coral',
    label: 'Coral',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #ff7e5f, #feb47b)',
      '--header-bg': 'linear-gradient(90deg, #ff758c, #ff7eb3)',
      '--menu-item-selected': 'linear-gradient(90deg, #ff9a9e, #fad0c4)',
      '--menu-item-hover': 'linear-gradient(90deg, #fad0c4, #ff9a9e)',
      '--header-title': '#ff7e5f',
      '--profile-avatar': '#ff758c',
      '--welcome-text': '#ff758c',
      '--welcome-mse': '#888',
      '--have-a-nice-day': '#eee',
      '--description-branch': '#eee',
    },
    previewColor: '#ff7e5f',
  },
  {
    key: 'graphite',
    label: 'Graphite',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #434343, #000000)',
      '--header-bg': 'linear-gradient(90deg, #232526, #414345)',
      '--menu-item-selected': 'linear-gradient(90deg, #606c88, #3f4c6b)',
      '--menu-item-hover': 'linear-gradient(90deg, #3f4c6b, #606c88)',
      '--header-title': '#ffffff',
      '--profile-avatar': '#777777',
      '--welcome-text': '#ffffff',
      '--welcome-mse': '#555',
      '--have-a-nice-day': '#fff',
      '--description-branch': '#fff',
    },
    previewColor: '#434343',
  },
  {
    key: 'flamingo',
    label: 'Flamingo',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #ff9a9e, #fecfef)',
      '--header-bg': 'linear-gradient(90deg, #ffdde1, #ee9ca7)',
      '--menu-item-selected': 'linear-gradient(90deg, #ff758c, #ff7eb3)',
      '--menu-item-hover': 'linear-gradient(90deg, #ff7eb3, #ff758c)',
      '--header-title': '#ee9ca7',
      '--profile-avatar': '#ff9a9e',
      '--welcome-text': '#ee9ca7',
      '--welcome-mse': '#888',
      '--have-a-nice-day': '#aaa',
      '--description-branch': '#aaa',
    },
    previewColor: '#ff758c',
  },
  {
    key: 'neon',
    label: 'Neon',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #12c2e9, #c471ed, #f64f59)',
      '--header-bg': 'linear-gradient(90deg, #f64f59, #c471ed, #12c2e9)',
      '--menu-item-selected': 'linear-gradient(90deg, #12c2e9, #f64f59)',
      '--menu-item-hover': 'linear-gradient(90deg, #f64f59, #12c2e9)',
      '--header-title': '#ffffff',
      '--profile-avatar': '#f64f59',
      '--welcome-text': '#ffffff',
      '--welcome-mse': '#555',
      '--have-a-nice-day': '#bbb',
      '--description-branch': '#bbb',
    },
    previewColor: '#f64f59',
  },
  {
    key: 'forest',
    label: 'Forest',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #5a3f37, #2c7744)',
      '--header-bg': 'linear-gradient(90deg, #11998e, #38ef7d)',
      '--menu-item-selected': 'linear-gradient(90deg, #00c853, #64dd17)',
      '--menu-item-hover': 'linear-gradient(90deg, #64dd17, #00c853)',
      '--header-title': '#38ef7d',
      '--profile-avatar': '#00c853',
      '--welcome-text': '#38ef7d',
      '--welcome-mse': '#555',
      '--have-a-nice-day': '#ccc',
      '--description-branch': '#ccc',
    },
    previewColor: '#2c7744',
  },
  {
    key: 'frost',
    label: 'Frost',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #e0eafc, #cfdef3)',
      '--header-bg': 'linear-gradient(90deg, #89f7fe, #66a6ff)',
      '--menu-item-selected': 'linear-gradient(90deg, #66a6ff, #89f7fe)',
      '--menu-item-hover': 'linear-gradient(90deg, #89f7fe, #66a6ff)',
      '--header-title': '#66a6ff',
      '--profile-avatar': '#89f7fe',
      '--welcome-text': '#66a6ff',
      '--welcome-mse': '#555',
      '--have-a-nice-day': '#ddd',
      '--description-branch': '#ddd',
    },
    previewColor: '#66a6ff',
  },
  {
    key: 'amber',
    label: 'Amber',
    variables: {
      '--sidebar-bg': 'linear-gradient(180deg, #ffb347, #ffcc33)',
      '--header-bg': 'linear-gradient(90deg, #f6d365, #fda085)',
      '--menu-item-selected': 'linear-gradient(90deg, #fda085, #f6d365)',
      '--menu-item-hover': 'linear-gradient(90deg, #f6d365, #fda085)',
      '--header-title': '#ff9800',
      '--profile-avatar': '#ffb347',
      '--welcome-text': '#ff9800',
      '--welcome-mse': '#888',
      '--have-a-nice-day': '#eee',
      '--description-branch': '#eee',
    },
    previewColor: '#ffb347',
  }
];
